function isKetchPreferencesLink(link) {
  if (!link || link.tagName !== 'A') return false;
  if (link.hasAttribute('data-ketch-preferences')) return true;

  const href = (link.getAttribute('href') || '').toLowerCase();
  return href.includes('ketch_show=preferences') || href === '#ketch-preferences';
}

function showKetchPreferences(event) {
  event.preventDefault();

  if (typeof ketch === 'function') {
    ketch('showPreferences');
    return;
  }

  const url = new URL(window.location.href);
  url.searchParams.set('ketch_show', 'preferences');
  window.location.assign(url);
}

function handleKetchPreferencesClick(event) {
  const link = event.target.closest('a');
  if (!isKetchPreferencesLink(link)) return;

  showKetchPreferences(event);
}

function initKetchFooterLinks() {
  if (document.documentElement.dataset.ketchFooterLinksBound === 'true') return;
  document.documentElement.dataset.ketchFooterLinksBound = 'true';

  document.addEventListener('click', handleKetchPreferencesClick);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKetchFooterLinks);
} else {
  initKetchFooterLinks();
}

document.addEventListener('shopify:section:load', initKetchFooterLinks);
